module.exports = __webpack_public_path__ + "static/media/44514346_2199902740084905_29634552787894272_o.913f540e.jpg";